























import { Vue, Component, Prop } from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';
@Component({
  components: {
    apexchart: VueApexCharts,
  },
})
export default class RadialBarChart extends Vue {
  @Prop({ type: Array, required: true }) series!: ApexNonAxisChartSeries;
  @Prop({ type: Number, required: true }) completed!: number;
  @Prop({ type: Number, required: true }) open!: number;
  @Prop({ type: String, required: true }) title!: string;

  chartOptions: ApexOptions = {
    colors: ['#28C76F'],
    chart: {
      type: 'radialBar',
      height: 350,
      offsetY: -10,
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            offsetY: 0,
            fontSize: '30px',
            color: undefined,
            formatter: function (val) {
              return val + '%';
            },
          },
        },
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        shadeIntensity: 0.15,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 65, 91],
      },
    },
    stroke: {
      dashArray: 6,
    },
    labels: [],
  };
}
